import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function kpiHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'kpiHeader',
    baseStyle: {
      color: theme.colors.muted,
      fontSize: theme.sizes[0]
    },
    variants: {
      linkCardHeader: {
        fontSize: theme.sizes['-1']
      }
    }
  };
}
